module.exports = __webpack_public_path__ + "static/media/phone-square-alt.a79a2f55.svg";